import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, catchError, of, switchMap } from "rxjs";
import { PerguntasFrequentesService } from "src/app/services/perguntas-frequentes.service";
import { listarPerguntasFrequentes, listarPerguntasFrequentesFailure, listarPerguntasFrequentesSuccess } from "../actions/perguntas-frequentes.action";

@Injectable()
export class ListarPerguntasFrequentesEffects {

  public listarPerguntasFrequentes$: unknown;

  constructor(private actions$: Actions,
    private perguntasFrequentesService: PerguntasFrequentesService) {
    this.createEffects()
  }

  private createEffects() {
    this.listarPerguntasFrequentes$ = createEffect(() => this.actions$.pipe(
      ofType(listarPerguntasFrequentes),
      switchMap(({ perguntasFrequentesInputDto }) =>
        this.perguntasFrequentesService
          .listarPerguntasFrequentes(perguntasFrequentesInputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return listarPerguntasFrequentesFailure({ response })
              }
              return listarPerguntasFrequentesSuccess({ response })
            }),
            catchError(() => {
              return of()}
            )
          )
      )
    )
    );
  }
}
